<script>
  //import Multiselect from "@vueform/multiselect";
  import "@vueform/multiselect/themes/default.css";
  // import flatPickr from "vue-flatpickr-component";
  // import "flatpickr/dist/flatpickr.css";
  import Select2 from 'vue3-select2-component';
  import axios from 'axios';
  import Layout from "../../../layouts/main.vue";
  import PageHeader from "@/components/page-header";
  import appConfig from "../../../../app.config";
  import moment from 'moment';
  import Swal from "sweetalert2";

  export default {
    page: {
      title: "Create Invoice",
      meta: [{
        name: "description",
        content: appConfig.description
      }],
    },
    data() {
      return {
        title: "Create Invoice",
        items: [{
            text: "Create Invoice",
          },
        ],
        customerbilling_info:[],
        currentInvoiceNumber:[],
        listCustomer: [],
        name_as_per_nric:'',
        address:'',
        postalcode:'',
        city:'',
        state_name:'',
        phone_number:'',
        email:'',
        imei:'',
        product:'',
        invoice_number:'',
        issue_date:'',
        due_date:'',
        fullAddress:'',
        description:'',
        form: {
          amount: null,
          credit: null,
          total_amount: null,
        },
        submitLoading: false,
      };
    },
    components: {
      Layout,
      PageHeader,
      Select2, 
      //Multiselect,
      // flatPickr,
    },
    methods: {
          getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },
      async fetchGstPercentage() {
        try {
          const response = await axios.get(process.env.VUE_APP_API_BASEURL + 'gst-percentage', {
            headers: { 'authorization': 'Bearer ' + localStorage.getItem('jwt') }
          });
          this.gstRate = response.data.gst_percentage / 100; // Convert percentage to decimal (e.g., 9 -> 0.09)
        } catch (error) {
          console.error('Failed to fetch GST percentage:', error);
          Swal.fire({
            title: "Failed to fetch GST percentage. Using default rate (9%).",
            icon: "warning",
          });
          this.gstRate = 0.09; // Fallback to 9%
        }
      },
      getCustomerBillingInfo(id){
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.get(process.env.VUE_APP_AR_API_BASEURL+'customer/getCustomerBillingInfo/'+id)
          .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.customerbilling_info = response.data;
                // this.name_as_per_nric = this.customerbilling_info.name_as_per_nric;
                this.address = this.customerbilling_info.address;
                this.postalcode = this.customerbilling_info.postalcode;
                this.city = this.customerbilling_info.city;
                this.state_name = this.customerbilling_info.state_name;
                this.phone_number = this.customerbilling_info.phone_number;
                this.email = this.customerbilling_info.email;
                this.imei = this.customerbilling_info.imei;
                this.product = this.customerbilling_info.product_name;
                this.fullAddress = this.customerbilling_info.address+'\n'+this.customerbilling_info.postalcode+', '+this.customerbilling_info.city;
          
                this.issue_date = moment(new Date()).format('DD-MM-YYYY');
                this.due_date = moment(new Date()).add(1, 'days').format('DD-MM-YYYY');
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
      },

      getInvoiceNumber(){
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/invoiceNumber')
          .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.invoice_number = response.data;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
      },

      create_invoice(e){

        e.preventDefault();
        if (this.name_as_per_nric == ''){
            alert('Please select customer'); 
        }else if (this.description == ''){
            alert('Please enter description'); 
        }
        else if (this.form.amount == 0 || this.form.amount == null){
            alert('Please enter amount'); 
        }
        else{

          Swal.fire({
              title: "Are you sure you want to create this invoice?",
              icon: "info",
              showCancelButton: true,
              cancelButtonColor: "#f46a6a",
              confirmButtonColor: "#34c38f",
              confirmButtonText: "Create Invoice",
          }).then((result) => {
              if (result.value) {
                  this.submitLoading = true;
                  const posting_ = {                
                      customer_id: this.name_as_per_nric,
                      invoice_number: this.invoice_number,
                      total_amount: this.form.amount,
                      gst: this.calculateGST,
                      balance_amount: this.calculateTotal,
                      credit_applied: this.form.credit,
                      description: this.description,
                  };

                  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                  axios.post(process.env.VUE_APP_AR_API_BASEURL+'invoice/create_invoice', posting_)
                  .then(response => {
                      console.log(response);
                      if (response.status == 201||response.status == 200) {
                          Swal.fire({
                              title:"Invoice created successfully", 
                              icon:"success",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              this.$router.push('/ar/invoices/invoice-listing');
                            }
                          });
                      } 
                      else {
                          Swal.fire({
                              title:"Failed to create invoice.", 
                              icon:"warning",
                          })
                      }
                  }).catch(function (error) {                    
                      Swal.fire({
                          title:error.response.data.msj, 
                          icon:"warning",
                      })
                  })
                  .finally(() => {
                    this.submitLoading = false;
                  });
              }
          });
        }
      },

      checkName(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/customers')
            .then(response => {
                if (response.data) {
                   this.listCustomer=response.data;
                   console.log(response.data);
                } 
                else {
                    this.messageBag = ['No record.'];
                    this.listCustomer=[];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getDetail({id, text}){
            console.log(id, text);
            this.getCustomerBillingInfo(id);
        }
    },

    computed: {
      calculateGST() {
        const amount = parseFloat(this.form.amount) || 0;
        return (amount * this.gstRate).toFixed(2);
      },
      calculateTotal() {
        const amount = parseFloat(this.form.amount) || 0;
        const credit = parseFloat(this.form.credit) || 0;
        const gst = parseFloat(this.calculateGST) || 0;
        return (amount + gst - credit).toFixed(2);
      },
    },

    mounted() {
    //   this.getCustomerBillingInfo();
      this.getInvoiceNumber();
      this.checkName();
      this.fetchGstPercentage();
    },
  };
</script>
<style>
.page-header {
  border-bottom: 3px dotted #E9EBEC;
}

.page-header-top {
  border-top: 3px dotted #E9EBEC;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center">
      <div class="col-xxl-10">
        <div class="card">
          <form @submit="create_invoice" class="needs-validation" novalidate >
            <div class="card-body border-bottom border-bottom-dashed p-4">
              <div class="row">
                <div class="col-lg-12">
                  <div class="d-sm-flex">
                        <div class="flex-grow-1">
                            <img src="@/assets/images/CA_new_logo_150x_2x-removebg.png" class="card-logo card-logo-dark" alt="logo dark" height="52">
                        </div>
                        <div class="flex-shrink-0 text-end p-3" style="max-width:40%">
                            <p>
                              CompAsia PTE. LTD. (201215376H)<br>
                            </p>      
                            <p class="text-muted fw-normal" id="legal-register-no">
                              100 Pasir Panjang Rd, <br>
                              #06-01, <br>
                              Singapore, 118518.
                              <br>
                              03-860 29290
                            </p>                                       
                        </div>
                    </div>  
                </div>            
              </div>
            </div>
            <div class="card-body p-4 border-bottom border-bottom-dashed">
              <div class="row">
                <div class="col-lg-5 col-sm-6">
                  <div>
                    <label for="billingName" class="text-muted text-uppercase fw-semibold">Billing Address</label>
                  </div>
                  <div class="mb-2">
                    <!-- <input type="text" class="form-control bg-light border-0" id="billingName" v-model='name_as_per_nric' readonly/> -->
                    <Select2 v-model="name_as_per_nric" :options="listCustomer" @select="getDetail($event)"></Select2>

                  </div>
                  <div class="mb-2">
                    <textarea class="form-control bg-light border-0" id="billingAddress" rows="3" v-model='fullAddress'></textarea>
                  </div>
                  <div class="mb-2">
                    <input type="text" class="form-control bg-light border-0" data-plugin="cleave-phone" id="billingPhoneno" v-model='phone_number' />
                  </div>
                </div>
                <!--end col-->
                <div class="col-sm-2 ms-auto">
                  <div class="row">
                    <div class="col-lg-8">
                       
                    </div>
                  </div>
                </div>
                <div class="col-sm-5 ms-auto">
                  <div class="row">
                    <div class="col-lg-10">
                        <table class="table table-borderless table-sm table-nowrap align-middle mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">Ref. No</th>
                            <td style="width: 200px">
                              <input type="text" class="form-control bg-light border-0" id="cart-subtotal" v-model='invoice_number' readonly />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">Issue Date</th>
                            <td>
                              <input type="text" class="form-control bg-light border-0" id="cart-tax" v-model='issue_date' readonly />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              Due Date
                            </th>
                            <td>
                              <input type="text" class="form-control bg-light border-0" id="cart-discount" v-model='due_date' readonly />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      
            <div class="card-body p-4">
              <div class="table-responsive">
                <table class="invoice-table table table-borderless table-nowrap mb-4">
                  <thead class="align-middle">
                    <tr class="table-active">
                      <th scope="col">#</th>
                      <th scope="col" width="75%">Description</th>
                      <th scope="col">Amount ({{ this.getCurrency() }})</th>
                    </tr>
                  </thead>
                  <tbody id="newlink" class="col-lg-12">

                    <tr>
                      <td>1</td>
                      <td>
                        <input placeholder="Monthly Fixed Charges 3/11" type="text" class="form-control" v-model='description' />
                        <br>
                        <p style="font-size:12px"><b>{{ product }}<br>IMEI: {{ imei }}</b></p>
                      </td>
                      <td>
                        <div>
                          <input class="form-control text-end" v-model="form.amount" type="number" name="amount" id="amount" />
                        </div>
                      </td>
                    </tr>

                    <tr class="page-header">
                      <td>
                        2
                      </td>
                      <td>
                        <input placeholder="Overpayment" type="text" class="form-control" />
                      </td>
                      <td>
                        <div>
                          <input class="form-control text-end" v-model="form.credit" type="number" name="credit" id="credit"/>
                        </div>
                      </td>
                    </tr>

                    <tr>
                         <td></td>
                      <td class="text-end">GST ({{ (gstRate * 100).toFixed(0) }}%)</td>
                      <td>
                        <div>
                          <input class="form-control text-end" :value="calculateGST" type="number" readonly />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td></td>
                      <td class="text-end">Total Amount ({{ this.getCurrency() }})</td>
                      <td>
                        <div>
                          <input class="form-control text-end" :value="calculateTotal" type="number" name="total_amount" id="total_amount" readonly />
                        </div>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
                <!--end table-->
              </div>

              <div class="hstack gap-2 justify-content-end d-print-none mt-5">
                <!-- <a href="javascript:void(0);" class="btn btn-success"><i class="ri-printer-line align-bottom me-1"></i> Print</a> -->
                <!-- <a href="javascript:void(0);" class="btn btn-primary"><i class="ri-download-2-line align-bottom me-1"></i> Download Invoice</a> -->
                <div v-if="submitLoading" class="spinner-border text-success">
                    <span class="sr-only">Loading...</span>
                </div>
                <button v-if="!submitLoading" type="submit" class="btn btn-danger"><i class="ri-send-plane-fill align-bottom me-1"></i>
                    Send Invoice
                  </button>
                
              </div>
            </div>
          </form>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </Layout>
</template>